<div class="container-fluid basic_table cac-root">
  <div class="row">
    <div class="col-sm-12">
      <div class="card cac-card">
        <header class="report-page-header cac-header">
          <button type="button" class="cac-back-btn" (click)="goBackToCustomers()">
            <i class="fa fa-arrow-right" aria-hidden="true"></i>
            <span>{{ translate.instant('customers.accountCard.backToCustomers') }}</span>
          </button>
          <div class="report-page-heading">
            <h1>{{ translate.instant('customerBalances.statement.title') }}</h1>
            <p class="report-page-sub" *ngIf="customerDisplayName !== '—'">
              {{ customerDisplayName }}
              <span class="cac-meta-sep">·</span>
              <span class="cac-meta-id">{{ customerNumberDisplay }}</span>
            </p>
          </div>
          <div class="report-page-actions cac-header-actions">
            <button
              type="button"
              class="cac-btn cac-btn--ghost"
              (click)="loadStatement()"
              [disabled]="loading || !companyId || !fromDate || !toDate">
              <i class="fa fa-refresh" [class.fa-spin]="loading"></i>
              <span>{{ translate.instant('customerBalances.actions.refresh') }}</span>
            </button>
            <button
              type="button"
              class="cac-btn cac-btn--excel"
              (click)="exportExcel()"
              [disabled]="loading || !companyId || !fromDate || !toDate">
              <i class="fa fa-file-excel-o"></i>
              <span>{{ translate.instant('customers.accountCard.exportExcel') }}</span>
            </button>
            <button
              type="button"
              class="cac-btn cac-btn--pdf"
              (click)="exportPdf()"
              [disabled]="loading || !companyId || !fromDate || !toDate">
              <i class="fa fa-file-pdf-o"></i>
              <span>{{ translate.instant('customerBalances.actions.export_pdf') }}</span>
            </button>
          </div>
        </header>

        <div class="card-body cac-body">
          <div class="alert alert-warning cac-alert" *ngIf="!companyId">
            <i class="fa fa-exclamation-triangle"></i>
            {{ translate.instant('customerBalances.warnings.no_company') }}
          </div>

          <section class="cac-kpi-grid" *ngIf="accountSummary">
            <article class="cac-kpi">
              <span class="cac-kpi__label">{{ translate.instant('customers.accountCard.summary.opening') }}</span>
              <span class="cac-kpi__value">{{ formatBalance(accountSummary.initial_balance) }}</span>
            </article>
            <article class="cac-kpi">
              <span class="cac-kpi__label">{{ translate.instant('customerBalances.table.columns.debit') }}</span>
              <span class="cac-kpi__value cac-kpi__value--debit">{{ formatBalance(accountSummary.total_debit) }}</span>
            </article>
            <article class="cac-kpi">
              <span class="cac-kpi__label">{{ translate.instant('customerBalances.table.columns.credit') }}</span>
              <span class="cac-kpi__value cac-kpi__value--credit">{{ formatBalance(accountSummary.total_credit) }}</span>
            </article>
            <article class="cac-kpi cac-kpi--primary">
              <span class="cac-kpi__label">{{ translate.instant('customerBalances.table.columns.current_balance') }}</span>
              <span class="cac-kpi__value">{{ formatBalance(accountSummary.final_balance) }}</span>
            </article>
          </section>

          <section class="cac-filters">
            <div class="cac-filters__head">
              <h2 class="cac-filters__title">{{ translate.instant('customers.accountCard.filters.title') }}</h2>
              <span class="cac-filters__period" *ngIf="fromDate && toDate">
                {{ formatDisplayDate(fromDate) }} — {{ formatDisplayDate(toDate) }}
              </span>
            </div>

            <div class="cac-filters__grid">
              <div class="cac-field">
                <label class="cac-field__label">{{ translate.instant('customerBalances.filters.fromDate') }}</label>
                <p-calendar
                  [(ngModel)]="fromDate"
                  styleClass="cac-calendar"
                  inputStyleClass="cac-calendar-input"
                  [showIcon]="true"
                  icon="pi pi-calendar"
                  dateFormat="dd/mm/yy"
                  placeholder="DD/MM/YYYY"
                  [showButtonBar]="true"
                  appendTo="body"
                  [maxDate]="getMaxFromDate()"
                  (ngModelChange)="onDateChange()">
                </p-calendar>
              </div>
              <div class="cac-field">
                <label class="cac-field__label">{{ translate.instant('customerBalances.filters.toDate') }}</label>
                <p-calendar
                  [(ngModel)]="toDate"
                  styleClass="cac-calendar"
                  inputStyleClass="cac-calendar-input"
                  [showIcon]="true"
                  icon="pi pi-calendar"
                  dateFormat="dd/mm/yy"
                  placeholder="DD/MM/YYYY"
                  [showButtonBar]="true"
                  appendTo="body"
                  [minDate]="getMinToDate()"
                  (ngModelChange)="onDateChange()">
                </p-calendar>
              </div>
              <div class="cac-field cac-field--wide">
                <label class="cac-field__label">{{ translate.instant('customers.accountCard.filters.documentType') }}</label>
                <p-multiSelect
                  [options]="documentTypeOptions"
                  [(ngModel)]="selectedDocumentTypeCodes"
                  optionLabel="label"
                  optionValue="code"
                  [placeholder]="translate.instant('customers.accountCard.filters.allDocumentTypes')"
                  [filter]="true"
                  display="chip"
                  appendTo="body"
                  styleClass="cac-multiselect"
                  panelStyleClass="cac-multiselect-panel"
                  (onChange)="onDocumentTypeChange()">
                </p-multiSelect>
              </div>
              <div class="cac-field cac-field--wide">
                <label class="cac-field__label">{{ translate.instant('customers.accountCard.filters.searchMovements') }}</label>
                <span class="cac-search-wrap">
                  <i class="fa fa-search cac-search-icon" aria-hidden="true"></i>
                  <input
                    type="search"
                    class="form-control cac-search-input"
                    [(ngModel)]="searchTerm"
                    (input)="onSearchInput()"
                    [placeholder]="translate.instant('customers.accountCard.filters.searchPlaceholder')" />
                </span>
              </div>
            </div>

            <div class="cac-alert cac-alert--error" *ngIf="dateRangeError">
              <i class="fa fa-exclamation-circle"></i>
              {{ dateRangeError }}
            </div>

            <div class="cac-account-type">
              <span class="cac-account-type__label">{{ translate.instant('merchant-info.common.accountTypeLabel') }}</span>
              <div class="cac-segment" role="radiogroup">
                <label class="cac-segment__option" [class.is-active]="accountType === false">
                  <input
                    type="radio"
                    name="accountTypeCard"
                    [checked]="accountType === false"
                    (change)="accountType = false; onAccountTypeChange()" />
                  <span>{{ translate.instant('merchant-info.common.accountTypeTaxInvoice') }}</span>
                </label>
                <label class="cac-segment__option" [class.is-active]="accountType === true">
                  <input
                    type="radio"
                    name="accountTypeCard"
                    [checked]="accountType === true"
                    (change)="accountType = true; onAccountTypeChange()" />
                  <span>{{ translate.instant('merchant-info.common.accountTypeFinancialClaim') }}</span>
                </label>
              </div>
            </div>
          </section>

          <div class="cac-loading" *ngIf="loading">
            <i class="fa fa-spinner fa-spin"></i>
            <span>{{ translate.instant('customerBalances.statement.loading') }}</span>
          </div>

          <div class="cac-alert cac-alert--error" *ngIf="!loading && loadError">
            <i class="fa fa-exclamation-circle"></i>
            {{ loadError }}
          </div>

          <section class="cac-table-section d-none d-md-block" *ngIf="!loading && !loadError">
            <div class="table-responsive cac-table-scroll">
              <table class="cac-table">
                <thead>
                  <tr>
                    <th>{{ translate.instant('customerBalances.statement.columns.date') }}</th>
                    <th>{{ translate.instant('customers.accountCard.table.movementType') }}</th>
                    <th>{{ translate.instant('customers.accountCard.table.documentNumber') }}</th>
                    <th>{{ translate.instant('customers.accountCard.table.description') }}</th>
                    <th class="cac-num">{{ translate.instant('customerBalances.statement.columns.debit') }}</th>
                    <th class="cac-num">{{ translate.instant('customerBalances.statement.columns.credit') }}</th>
                    <th class="cac-num">{{ translate.instant('customerBalances.statement.columns.balance') }}</th>
                    <th class="cac-actions-col">{{ translate.instant('customerBalances.statement.columns.actions') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="cac-row-opening">
                    <td colspan="5" class="cac-opening-label">{{ translate.instant('customerBalances.statement.openingBalance') }}</td>
                    <td></td>
                    <td class="cac-num cac-num--strong">{{ formatStatementAmount(statementInitialBalance, false) }}</td>
                    <td></td>
                  </tr>
                  <tr
                    *ngFor="let row of statementRows"
                    [class.cac-row-entry]="isAccountEntryRow(row)">
                    <td class="cac-date">{{ row.formatted_date || row.invoice_date || '—' }}</td>
                    <td>
                      <span class="cac-type-pill">{{ getStatementRowTypeLabel(row) }}</span>
                    </td>
                    <td>
                      <span class="cac-doc">{{ row.document_number || '—' }}</span>
                      <span class="cac-entry-badge" *ngIf="isAccountEntryRow(row)">
                        {{ translate.instant('customerBalances.statement.accountEntryBadge') }}
                      </span>
                    </td>
                    <td class="cac-desc" [title]="row.invoice_note || ''">{{ row.invoice_note || '—' }}</td>
                    <td class="cac-num cac-num--debit">{{ formatStatementAmount(row.formatted_debit_amount) }}</td>
                    <td class="cac-num cac-num--credit">{{ formatStatementAmount(row.formatted_credit_amount) }}</td>
                    <td class="cac-num cac-num--strong">{{ formatStatementAmount(row.formatted_running_balance ?? row.running_balance, false) }}</td>
                    <td class="cac-actions-col">
                      <button
                        *ngIf="canOpenRowPdf(row)"
                        type="button"
                        class="cac-row-pdf-btn"
                        (click)="openRowPdf(row, $event)"
                        [title]="translate.instant('customerBalances.statement.openPdf')">
                        <i class="fa fa-file-pdf-o"></i>
                      </button>
                      <span *ngIf="!canOpenRowPdf(row)" class="cac-muted">—</span>
                    </td>
                  </tr>
                  <tr *ngIf="!statementRows.length">
                    <td colspan="8" class="cac-empty">
                      <i class="fa fa-inbox"></i>
                      {{ translate.instant('customerBalances.statement.empty') }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section class="cac-mobile d-md-none" *ngIf="!loading && !loadError">
            <div class="cac-mobile-opening">
              <span>{{ translate.instant('customerBalances.statement.openingBalance') }}</span>
              <strong>{{ formatStatementAmount(statementInitialBalance, false) }}</strong>
            </div>
            <article class="cac-mobile-card" *ngFor="let row of statementRows">
              <div class="cac-mobile-card__top">
                <time>{{ row.formatted_date || row.invoice_date || '—' }}</time>
                <strong>{{ formatStatementAmount(row.formatted_running_balance ?? row.running_balance, false) }}</strong>
              </div>
              <div class="cac-type-pill cac-type-pill--sm">{{ getStatementRowTypeLabel(row) }}</div>
              <div class="cac-mobile-card__doc">{{ row.document_number || '—' }}</div>
              <p class="cac-mobile-card__note" *ngIf="row.invoice_note">{{ row.invoice_note }}</p>
              <div class="cac-mobile-card__amounts">
                <span>{{ translate.instant('customerBalances.statement.columns.debit') }}: {{ formatStatementAmount(row.formatted_debit_amount) }}</span>
                <span>{{ translate.instant('customerBalances.statement.columns.credit') }}: {{ formatStatementAmount(row.formatted_credit_amount) }}</span>
              </div>
            </article>
            <div class="cac-empty cac-empty--mobile" *ngIf="!statementRows.length">
              <i class="fa fa-inbox"></i>
              {{ translate.instant('customerBalances.statement.empty') }}
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</div>
